import { deleteSafeMake } from "actions/Utilities/SafeMake";
import { toast } from "components/toastNotification";
import React from "react";
import { useMutation } from "react-query";
import { useRecoilState } from "recoil";
import { safeMakeReFetching } from "../atoms/atoms";

export default function useDeleteSafeMake() {
  const [isReFetching, setIsReFetching] = useRecoilState(safeMakeReFetching);
  const { mutate } = useMutation((ids: number[]) => deleteSafeMake(ids), {
    onSuccess: (res: any) => {
      if (typeof res == "object") {
        toast.fire("Disabling Safe Make failed", res.Message, "error");
      } else {
        switch (true) {
          case res == "Success":
            toast.fire("Success", "Safe Make Disabled Successfully", "success");
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Safe Make Disabled Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Disabling Safe Make failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "Safe Make not found":
            toast.fire("Disabling Safe Make failed ", `Error: ${res}`, "error");
            break;
          default:
            toast.fire("Disabling Safe Make failed", res, "error");
        }
      }
      // ReFetch Data
      setIsReFetching(isReFetching ? false : true);
    },
    onError: (error) => {
      toast.fire("Disabling Safe Make failed", `Error: ${error}`, "error");
    },
  });

  return mutate;
}
